import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import TagManager from 'react-gtm-module';
import { BrowserRouter, } from 'react-router-dom';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { WagmiProvider } from 'wagmi';
import { createAppKit } from '@reown/appkit/react';
import { arbitrum, mainnet, polygon } from '@reown/appkit/networks';
import { CAPTCHA_TOKEN } from 'config/constants';
import { environment } from 'config/environment';
import ModalProvider from 'providers/modal';
import SessionProvider from 'providers/session';
import SnackbarProvider from 'providers/snackbar';
import ThemeProvider from 'providers/theme';
import { Snackbar, Toast } from 'ui';
import Settings from 'utils/Settings';
import App from './App';
import './i18n';
var container = document.getElementById('root');
var root = createRoot(container);
var projectId = '92a7d4ac291a30730d0e8d2a71f85f34';
var networks = [mainnet, arbitrum, polygon];
var metadata = {
    name: 'Flixxo',
    description: 'Flixxo',
    url: 'https://play.flixxo.com',
    icons: ['https://play.flixxo.com/favicon.png'],
};
var wagmiAdapter = new WagmiAdapter({ networks: networks, projectId: projectId });
createAppKit({
    adapters: [wagmiAdapter],
    networks: networks,
    metadata: metadata,
    projectId: projectId,
    features: {
        analytics: false,
        socials: false,
        swaps: false,
        history: false,
        onramp: false,
        // emailShowWallets: false,
        smartSessions: false,
        // email: false,
        // allWallets: false
    },
});
export var Index = function () {
    var queryClient = useState(function () { return new QueryClient({
        defaultOptions: {
            queries: {
                retry: 1,
                retryDelay: 300,
            },
        },
    }); })[0];
    useEffect(function () {
        ReactGA.initialize(environment.GA4_ID);
        if (environment.isProduction) {
            TagManager.initialize({ gtmId: environment.GTM_ID });
            if (window.fbq) {
                window.fbq('init', '339303390613594');
                window.fbq('track', 'PageView');
            }
        }
    }, []);
    return (_jsx(GoogleReCaptchaProvider, { reCaptchaKey: CAPTCHA_TOKEN, children: _jsx(BrowserRouter, { children: _jsx(WagmiProvider, { config: wagmiAdapter.wagmiConfig, children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(ReactQueryDevtools, {}), _jsx(SnackbarProvider, { children: _jsx(SessionProvider, { children: _jsx(GoogleOAuthProvider, { clientId: environment.GOOGLE_ID, children: _jsx(ModalProvider, { children: _jsxs(ThemeProvider, { children: [_jsx(Toast.Provider, {}), _jsx(Snackbar, {}), _jsx(App, {}), !environment.isProduction && (_jsx(Settings, {}))] }) }) }) }) })] }) }) }) }));
};
root.render(_jsx(Index, {}));
